import { InjectionToken } from '@angular/core';
import { LogLevel } from '..';

export const CURRENT_ENV = new InjectionToken<string>('CURRENT_ENV');
export const ENVIRONMENT_CONFIG = new InjectionToken<string>('ENVIRONMENT_CONFIG');
export const DEBUGGING_ENABLED = new InjectionToken<string>('DEBUGGING_ENABLED')
export const LOG_LEVEL = new InjectionToken<string>('LOG_LEVEL')
